import { render } from "./Galeri.vue?vue&type=template&id=ca418d1a"
import script from "./Galeri.vue?vue&type=script&lang=js"
export * from "./Galeri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__